import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	override: {
		id: 'eoc-schedule-common.common.ui.card.button.confirm-override',
		defaultMessage: 'Override',
		description: 'A override button.',
	},
	addOverride: {
		id: 'eoc-schedule-common.common.ui.card.button.add-override',
		defaultMessage: 'Add override',
		description: 'Adding override for a period item.',
	},
	editOverride: {
		id: 'eoc-schedule-common.common.ui.card.button.edit-override',
		defaultMessage: 'Edit override',
		description: 'Label for editing override.',
	},
	editDetails: {
		id: 'eoc-schedule-common.common.ui.card.button.edit-details',
		defaultMessage: 'Edit details',
		description: 'Text of button for customizing override at quick override step.',
	},
	removeOverride: {
		id: 'eoc-schedule-common.common.ui.card.button.remove-override',
		defaultMessage: 'Remove override',
		description: 'Label for deleting override.',
	},
});
